import { Radio, Badge } from "antd";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { IServerTab } from "src/Interfaces/commonDtos";

export interface Tab {
  title: string;
  id: string;
  className?: string;
  count?: number;
}

interface TabBoxProps {
  children: Array<IServerTab>;
  defaultTabLink?: string;
}

const ServerTabBox = ({ children, defaultTabLink }: TabBoxProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const defaultValue = searchParams.get("activeTab") || "";
    if (children && children.length && !defaultValue) {
      const defaultTab = children.find(tab => tab.link === defaultTabLink) ?? children[0];
      navigate("/" + defaultTab.link);
    }
  }, [children, defaultTabLink]);

  const onClick = (link: string) => {
    navigate("/" + link);
  };

  const isActive = (link: string) => {
    return (
      link === (window.location.pathname + window.location.search).slice(1)
    );
  };

  const getValue = () =>
    (window.location.pathname + window.location.search).slice(1);

  return (
    <Radio.Group
      size="small"
      value={getValue()}
      className="w-full flex flex-row justify-start items-start"
    >
      {children?.map((tab) => (
        <>
          <Radio.Button
            key={tab.link}
            value={tab.link}
            onChange={() => onClick(tab.link)}
            checked={isActive(tab.link)}
            className={`flex grow justify-center items-center whitespace-nowrap before:!hidden !text-xs ${
              isActive(tab.link)
                ? "!bg-sky-600 hover:!bg-sky-700 !text-white"
                : "!border-gray-300 !text-gray-300 hover:!text-gray-400"
            }`}
          >
            {tab.title}
          </Radio.Button>
        </>
      ))}
    </Radio.Group>
  );
};

export default ServerTabBox;
